import {createUseStyles} from 'react-jss';
import color from 'color';
import MediaQueries from '../../style-helper/MediaQueries';
import Spacing from '../../style-helper/Spacing';

const backgroundColor = props => (props.theme.overlayBackgroundColour ? props.theme.overlayBackgroundColour : '#fff');

export default createUseStyles({
  overlayHeader: {
    // If sticky is not available on the browser (IE11), break gracefully by ensuring the close button is still positioned correctly
    position: props => (!props.title && !props.sticky ? 'absolute' : ('sticky' || 'relative')),
    zIndex: 2,
    top: 0,
    right: props => !props.title && 0,
    height: props => (!props.title && !props.sticky) && 48,
    display: 'flex',
    flex: 'none',
    textAlign: 'center',
    borderBottom: props => (!props.title ? 'none' : '1px solid #ccc'),
    backgroundColor: (props) => {
      if (!props.title) {
        return props.fullWidthOverlay ? '#fff' : 'transparent';
      }
      return props.fullWidthOverlay ? '#fff' : backgroundColor(props);
    },
    width: props => props.fullWidthOverlay && 550,
    [MediaQueries.phone]: {
      position: props => (!props.title && !props.sticky) && 'relative',
    },
  },
  
  exitButton: {
    display: 'flex',
    cursor: 'pointer',
    transition: '0.2s, background-color 0.4s',
    border: '2px solid transparent',
    background: props => backgroundColor(props),
    borderRadius: 0, // Always override Button's border radius styling
    height: 60,
    
    '&:hover, &:focus': {
      backgroundColor: props => color(backgroundColor(props)).darken(0.1).hex(),
    },
    
    '&:active': {
      backgroundColor: props => color(backgroundColor(props)).darken(0.1).hex(),
    },
  },
  
  label: {
    fontFamily: props => props.theme.sectionHeader.fontFamily,
    fontSize: props => props.theme.sectionHeader.fontSize,
    lineHeight: '24px',
    display: 'flex',
    alignItems: 'center',
    flex: 'auto',
    margin: Spacing.double,
    textAlign: 'left',
    fontStyle: 'normal',
    fontWeight: props => props.theme.sectionHeader.fontWeight || props.theme.core.boldFontWeight,
    color: props => props.theme.base.color,
    fontStretch: props => props.theme.sectionHeader.fontStretch,
    letterSpacing: props => props.theme.sectionHeader.letterSpacing,
    textTransform: props => props.theme.sectionHeader.isUppercase && 'uppercase',
  },
  
  buttonImage: {
    width: 24,
    height: 24,
    margin: 16, // this one requires the higher selectivity so it's not set to 0
    maxWidth: 'initial', // Negate the value in base.scss
    verticalAlign: 'text-top',
  },
});
